import { render, staticRenderFns } from "./ImagePreviewXhq.vue?vue&type=template&id=7a8675d4&scoped=true&"
import script from "./ImagePreviewXhq.vue?vue&type=script&lang=js&"
export * from "./ImagePreviewXhq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8675d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a8675d4')) {
      api.createRecord('7a8675d4', component.options)
    } else {
      api.reload('7a8675d4', component.options)
    }
    module.hot.accept("./ImagePreviewXhq.vue?vue&type=template&id=7a8675d4&scoped=true&", function () {
      api.rerender('7a8675d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/IntelligentBooking/components/ImagePreviewXhq.vue"
export default component.exports